import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import boopSound from '../sounds/boop.mp3';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null); // For the dropdown menu
  const audioRef = useRef(null);

  // Play sound effect
  const playSound = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget); // Open the menu
    playSound(); // Play sound effect
  };

  const handleMenuClose = () => {
    setAnchorEl(null); // Close the menu
    playSound(); // Play sound effect

  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng); // Change the language
    handleMenuClose(); // Close the menu after selection
    playSound(); // Play sound effect

  };

  return (
    <div>
          <audio ref={audioRef}>
        <source src={boopSound} type="audio/mp3" />
        Your browser does not support the audio element.
    </audio>
      {/* Language Icon Button */}
      <IconButton
        color="inherit"
        onClick={handleMenuOpen}
        sx={{ color: '#004aad' }} // Blue color for the icon
      >
        <LanguageIcon fontSize="small" /> {/* Language icon */}
      </IconButton>

      {/* Language Dropdown Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => changeLanguage('en')}>
          <Typography variant="body2">English</Typography>
        </MenuItem>
        <MenuItem onClick={() => changeLanguage('ar')}>
          <Typography variant="body2">العربية</Typography>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default LanguageSwitcher;